/**
 * Auth Module Types (Domain)
 *
 * Core authentication types and entities.
 * Keep domain types free of UI and framework dependencies.
 */

// Re-export User types from user module for convenience
export type { User, UserId } from '@/modules/user/domain/types';
export { UserRole } from '@/modules/user/domain/types';

// ============================================================================
// Authentication Types
// ============================================================================

/**
 * Authentication tokens
 */
export interface AuthTokens {
  accessToken: string;
  expiresIn: number; // seconds or milliseconds epoch
  tokenType: 'Bearer';
}

/**
 * Authentication state
 */
export enum AuthStatus {
  Idle = 'IDLE',
  Loading = 'LOADING',
  Authenticated = 'AUTHENTICATED',
  Unauthenticated = 'UNAUTHENTICATED',
  Error = 'ERROR',
}

/**
 * Social login providers
 */
export enum SocialProvider {
  Google = 'google',
}

// ============================================================================
// Re-exports (Request/Response DTOs)
// ============================================================================

export type {
  LoginRequest,
  LogoutRequest,
} from './requests';

export type {
  AuthResponse,
  TokenRefreshResponse,
  GoogleAuthUrlResponse,
} from './responses';
